// extracted by mini-css-extract-plugin
module.exports = {"title":"RemoveModulesConfirmationDialog_title__NuqSk","dialog":"RemoveModulesConfirmationDialog_dialog__2PqyY"};